import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { LoginUser } from "../models/auth";
import { LoginRequest } from "src/app/modules/login/models/login-request.model";

export namespace AuthActions {

  @logDispatcher
  export class Login {
    static readonly type = '[Auth] Login';
    constructor(public payload: LoginUser) {}
  }

  @logDispatcher
  export class LoginSuccess {
    static readonly type = '[Auth] LoginSuccess';
    constructor(public jwt: string) {}
  }

  @logDispatcher
  export class LoginFailed {
    static readonly type = '[Auth] LoginFailed';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class LoginSGC1 {
    static readonly type = '[Auth] LoginSGC1';
    constructor(public loginRequest: LoginRequest) {}
  }

  @logDispatcher
  export class SetUser {
    static readonly type = '[Auth] setUser';
  }

  @logDispatcher
  export class Logout {
    static readonly type = '[Auth] Logout';
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Auth] Error';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class SetDefaultState {
    static readonly type = '[Auth] SetDefaultState';
    constructor() {}
  }
}
